import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { Field } from 'redux-form';
import { WppSelect, WppListItem } from 'buildingBlocks';
import { DataProviderInterface } from 'buildingBlocks/TwoListMultiSelect/TwoListMultiSelect';

type Option = {
  text: string
  value: string
};

type AudienceReportMultiSelectProps = {
  name: string
  dataProvider: DataProviderInterface
  placeholder: string
};

const RenderWppSelect = ({ input, dataProvider, keyFn, displayFn, sortFn, placeholder }: any) => {
  const [options, setOptions] = useState<Array<Option>>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [selected, setSelected] = useState<string[]>([]);

  useEffect(() => {
    const fetchOptions = async () => {
      setLoading(true);
      const result = await dataProvider.queryWithPagination({ search: '', limit: 9999, skip: 0 });
      setOptions(result.elements);
      setLoading(false);
    };
    fetchOptions();
  }, [dataProvider]);

  useEffect(() => {
    const currentSelected = _.defaultTo(input.value, []);
    const values: string[] = _.map(currentSelected, keyFn);
    setSelected(values);
  }, [input.value, keyFn]);

  const handleChange = (event: CustomEvent) => {
    const selectedValues = event.detail.value;
    const selectedItems = _.filter(options, (item) => _.includes(selectedValues, keyFn(item)));
    input.onChange(selectedItems);
  };

  return (
    <WppSelect
      onWppChange={handleChange}
      type="multiple"
      value={selected}
      placeholder={placeholder}
      loading={loading}
      withSearch
      withFolder
    >
      {_.map(
        _.orderBy(options, sortFn ? [sortFn] : [], ['asc']),
        (option) => (
          <WppListItem key={keyFn(option)} value={keyFn(option)}>
            <p slot="label">{displayFn(option)}</p>
          </WppListItem>
        ),
      )}
    </WppSelect>
  );
};

export const AudienceReportMultiSelect = ({
  name,
  dataProvider,
  placeholder,
}: AudienceReportMultiSelectProps) => (
  <Field
    name={name}
    component={RenderWppSelect}
    dataProvider={dataProvider}
    keyFn={(option: Option) => option.value}
    displayFn={(option: Option) => option.text}
    sortFn={(option: Option) => option.text}
    placeholder={placeholder}
  />
);

export default AudienceReportMultiSelect;
